export const customerHeaderDe = {
  title: 'Kundendaten im Belegkopf',
  subtitle: 'Felder, Bereiche und externe Sichtbarkeit je Belegart festlegen.',
  documentType: 'Belegart',
  loading: 'Belegkopf-Konfiguration wird geladen …',
  loadError: 'Die Belegkopf-Konfiguration konnte nicht geladen werden.',
  retry: 'Erneut versuchen',
  save: 'Änderungen speichern',
  saving: 'Wird gespeichert …',
  saved: 'Die Belegkopf-Konfiguration wurde gespeichert.',
  saveError: 'Die Konfiguration konnte nicht gespeichert werden.',
  reset: 'Standard der Belegart wiederherstellen',
  resetTitle: 'Standard wiederherstellen?',
  resetDescription: 'Die individuelle Mandantenkonfiguration dieser Belegart wird entfernt.',
  resetDone: 'Der Standard der Belegart wurde wiederhergestellt.',
  cancel: 'Abbrechen',
  confirm: 'Wiederherstellen',
  unsaved: 'Nicht gespeicherte Änderungen',
  default: 'Belegart-Standard',
  fieldsTitle: 'Verfügbare Kundendaten',
  fieldsHint: 'Suchen oder filtern und mit „Hinzufügen“ in den Belegkopf übernehmen.',
  search: 'Felder und Kategorien durchsuchen',
  allSources: 'Alle Felder',
  standardFields: 'Standardfelder',
  customFields: 'Zusatzfelder',
  allCategories: 'Alle Kategorien',
  add: 'Hinzufügen',
  selected: 'Ausgewählt',
  noFields: 'Keine passenden Felder gefunden.',
  previousPage: 'Vorherige Seite',
  nextPage: 'Nächste Seite',
  page: 'Seite {{page}} von {{pages}}',
  layoutTitle: 'Bereiche und Reihenfolge',
  layoutHint:
    'Ziehen oder mit den Pfeiltasten verschieben. Änderungen gelten erst nach dem Speichern.',
  addSection: 'Eigenen Bereich anlegen',
  sectionName: 'Bereichsname',
  sectionNameLocale: 'Bezeichnung ({{locale}})',
  createSection: 'Bereich anlegen',
  emptyLayout: 'Noch keine Bereiche ausgewählt. Fügen Sie links ein Feld oder einen Bereich hinzu.',
  emptySection: 'Dieser Bereich enthält noch keine Felder.',
  context: 'Darstellung bearbeiten',
  contexts: { internal: 'Intern im ERP', pdf: 'PDF / Ausdruck', portal: 'Kundenportal' },
  sectionVisible: 'Bereich sichtbar',
  columns: 'Spalten',
  density: 'Darstellung',
  densities: { COMPACT: 'Kompakt', DETAILED: 'Ausführlich' },
  fieldVisibility: 'Sichtbarkeit',
  internal: 'Intern',
  pdf: 'PDF',
  portal: 'Portal',
  sensitive: 'Vertraulich – nur intern',
  showLabel: 'Label anzeigen',
  hideEmpty: 'Leere Werte ausblenden',
  highlight: 'Intern hervorheben',
  width: 'Breite',
  wrap: 'Langer Text',
  wraps: { WRAP: 'Umbrechen', TRUNCATE: 'Kompakt kürzen' },
  editLabels: 'Mehrsprachige Bezeichnung bearbeiten',
  remove: 'Feld ausblenden',
  moveUp: 'Nach oben',
  moveDown: 'Nach unten',
  moveSectionUp: 'Bereich nach oben',
  moveSectionDown: 'Bereich nach unten',
  dragSection: 'Bereich per Drag-and-drop verschieben',
  dragField: 'Feld per Drag-and-drop verschieben',
  deleteSection: 'Bereich entfernen',
  previewTitle: 'Strukturvorschau',
  previewHint: 'Die Vorschau zeigt ausschließlich Aufbau und Freigaben, keine Kundenwerte.',
  hiddenForContext: 'In dieser Ansicht ausgeblendet',
  validationTitle: 'Die Konfiguration konnte nicht gespeichert werden',
  editor: {
    title: 'Gespeicherte Kundendaten',
    snapshotAt: 'Belegstand vom {{date}}',
    densityLabel: 'Darstellung der Kundendaten',
    openCustomer: 'Kundenakte öffnen',
    manageStandard: 'Belegart-Standard verwalten',
    checkCurrent: 'Aktuelle Kundendaten prüfen',
    saveBeforeRefresh: 'Speichern Sie zuerst die offenen Belegänderungen.',
    internalOnly: 'Nur intern',
    showFullValue: 'Vollständigen Wert für {{field}} anzeigen',
    origins: {
      MASTER_DATA: 'Beim Erstellen aus dem Kundenstamm',
      DOCUMENT_VALUE: 'Im Beleg gespeichert',
      INHERITED: 'Aus dem Vorgängerbeleg',
      MANUAL_OVERRIDE: 'Im Beleg manuell geändert',
      BACKFILL_CURRENT_MASTER: 'Beim sicheren Altbeleg-Backfill erfasst',
    },
    backfillTitle: 'Herkunft bei Altbeleg eingeschränkt',
    backfillDescription:
      'Adressen stammen aus dem historischen Beleg. Bei zuvor live gelesenen Stammdaten ist der zum Backfill bekannte Stand eindeutig gekennzeichnet.',
    empty: 'Für diesen Beleg sind keine sichtbaren Kundendaten gespeichert.',
    refreshTitle: 'Aktuelle Kundendaten prüfen',
    refreshDescription:
      'Vergleichen Sie den gespeicherten Belegstand mit dem aktuellen Kundenstamm. Erst Ihre Auswahl ändert den Entwurf.',
    refreshLoading: 'Kundendaten werden verglichen …',
    refreshError: 'Der Vergleich konnte nicht geladen werden',
    refreshErrorDescription: 'Bitte versuchen Sie es erneut. Der Beleg wurde nicht verändert.',
    noRefreshChanges: 'Der Belegstand entspricht den aktuellen Kundendaten.',
    masterCheckedAt: 'Stammdatenstand: {{date}}',
    applyField: 'Aktuellen Wert für {{field}} übernehmen',
    documentValue: 'Gespeicherter Belegwert',
    masterValue: 'Aktueller Stammdatenwert',
    manualPreserved: 'Manuell geänderter Belegwert – wird nicht automatisch überschrieben.',
    refreshSaved: 'Die ausgewählten Kundendaten wurden in den Entwurf übernommen.',
    applyError: 'Die Auswahl konnte nicht übernommen werden. Der Beleg blieb unverändert.',
    applySelected: '{{count}} ausgewählte übernehmen',
    validation: {
      title: 'Bitte korrigieren Sie die markierten Eingaben',
      customerRequired: 'Wählen Sie einen Kunden aus.',
      recipientRequired: 'Geben Sie einen Belegempfänger ein.',
      itemRequired: 'Fügen Sie mindestens eine Belegposition hinzu.',
    },
  },
  override: {
    open: 'Kundendaten auswählen',
    title: 'Kundendaten für diesen Beleg anpassen',
    description:
      'Diese Änderungen gelten nur für diesen Entwurf. Der Mandantenstandard bleibt unverändert. Folgebelege verwenden den Standard ihrer Belegart und übernehmen Werte nur für dort enthaltene Felder.',
    validationTitle: 'Die Beleganpassung konnte nicht gespeichert werden',
    selectedTitle: 'Auswahl und Vorschau',
    internalImpact: '{{count}} intern',
    externalImpact: '{{count}} in PDF oder Portal',
    labelLanguage: 'Label-Sprache',
    externalPermissionHint: 'PDF- und Portal-Freigaben können nur Berechtigte ändern.',
    fieldLabel: 'Anzeigebezeichnung',
    section: 'Bereich',
    valueSource: 'Wert verwenden',
    keepValue: 'Gespeicherten Belegwert behalten',
    resetValue: 'Aus Kundenstamm wiederherstellen',
    overrideValue: 'Nur in diesem Beleg überschreiben',
    captureOnSave: 'Der passende Wert wird beim Speichern sicher erfasst.',
    resetValueHint: 'Beim Speichern wird der aktuelle Stammdatenwert übernommen.',
    sensitiveBlocked: 'Dieses Feld darf nicht in PDF oder Kundenportal erscheinen.',
    booleanYes: 'Ja',
    booleanNo: 'Nein',
    save: 'Beleganpassung speichern',
    saved: 'Die Kundendaten-Anpassung wurde für diesen Beleg gespeichert.',
    saveError: 'Die Beleganpassung konnte nicht gespeichert werden.',
  },
  documentTypes: {
    QUOTE: 'Angebot',
    ORDER: 'Auftrag / Auftragsbestätigung',
    DELIVERY_NOTE: 'Lieferschein',
    INVOICE: 'Rechnung',
    CANCELLATION: 'Stornobeleg',
    CREDIT_NOTE: 'Gutschrift',
    PURCHASE_ORDER: 'Bestellung',
  },
} as const;

export const customerHeaderEn = {
  ...customerHeaderDe,
  title: 'Customer data in document headers',
  subtitle: 'Configure fields, sections, and external visibility for each document type.',
  documentType: 'Document type',
  loading: 'Loading header configuration …',
  loadError: 'The header configuration could not be loaded.',
  retry: 'Try again',
  save: 'Save changes',
  saving: 'Saving …',
  saved: 'The header configuration was saved.',
  saveError: 'The configuration could not be saved.',
  reset: 'Restore document type default',
  resetTitle: 'Restore default?',
  resetDescription: 'The tenant-specific configuration for this document type will be removed.',
  resetDone: 'The document type default was restored.',
  cancel: 'Cancel',
  confirm: 'Restore',
  unsaved: 'Unsaved changes',
  default: 'Document type default',
  fieldsTitle: 'Available customer data',
  fieldsHint: 'Search or filter, then add a field to the document header.',
  search: 'Search fields and categories',
  allSources: 'All fields',
  standardFields: 'Standard fields',
  customFields: 'Custom fields',
  allCategories: 'All categories',
  add: 'Add',
  selected: 'Selected',
  noFields: 'No matching fields found.',
  previousPage: 'Previous page',
  nextPage: 'Next page',
  page: 'Page {{page}} of {{pages}}',
  layoutTitle: 'Sections and order',
  layoutHint: 'Drag or use the arrow buttons. Changes only apply after saving.',
  addSection: 'Create custom section',
  sectionName: 'Section name',
  sectionNameLocale: 'Label ({{locale}})',
  createSection: 'Create section',
  emptyLayout: 'No sections selected yet. Add a field or section.',
  emptySection: 'This section does not contain any fields yet.',
  context: 'Edit presentation',
  contexts: { internal: 'Internal ERP', pdf: 'PDF / print', portal: 'Customer portal' },
  sectionVisible: 'Show section',
  columns: 'Columns',
  density: 'Presentation',
  densities: { COMPACT: 'Compact', DETAILED: 'Detailed' },
  fieldVisibility: 'Visibility',
  internal: 'Internal',
  pdf: 'PDF',
  portal: 'Portal',
  sensitive: 'Confidential – internal only',
  showLabel: 'Show label',
  hideEmpty: 'Hide empty values',
  highlight: 'Highlight internally',
  width: 'Width',
  wrap: 'Long text',
  wraps: { WRAP: 'Wrap', TRUNCATE: 'Truncate in compact view' },
  editLabels: 'Edit multilingual label',
  remove: 'Hide field',
  moveUp: 'Move up',
  moveDown: 'Move down',
  moveSectionUp: 'Move section up',
  moveSectionDown: 'Move section down',
  dragSection: 'Move section by drag and drop',
  dragField: 'Move field by drag and drop',
  deleteSection: 'Remove section',
  previewTitle: 'Structure preview',
  previewHint: 'The preview shows structure and approvals only, never customer values.',
  hiddenForContext: 'Hidden in this view',
  validationTitle: 'The configuration could not be saved',
  editor: {
    title: 'Saved customer data',
    snapshotAt: 'Document snapshot from {{date}}',
    densityLabel: 'Customer data display',
    openCustomer: 'Open customer record',
    manageStandard: 'Manage document type default',
    checkCurrent: 'Check current customer data',
    saveBeforeRefresh: 'Save the pending document changes first.',
    internalOnly: 'Internal only',
    showFullValue: 'Show the full value for {{field}}',
    origins: {
      MASTER_DATA: 'Captured from the customer record',
      DOCUMENT_VALUE: 'Stored in the document',
      INHERITED: 'Inherited from the preceding document',
      MANUAL_OVERRIDE: 'Manually changed in the document',
      BACKFILL_CURRENT_MASTER: 'Captured during the safe legacy backfill',
    },
    backfillTitle: 'Limited provenance for legacy document',
    backfillDescription:
      'Addresses come from the historical document. Master data that used to be read live is explicitly marked with the state known at backfill time.',
    empty: 'No visible customer data is stored for this document.',
    refreshTitle: 'Check current customer data',
    refreshDescription:
      'Compare the saved document snapshot with the current customer record. The draft changes only after you confirm a selection.',
    refreshLoading: 'Comparing customer data …',
    refreshError: 'The comparison could not be loaded',
    refreshErrorDescription: 'Please try again. The document was not changed.',
    noRefreshChanges: 'The document snapshot matches the current customer data.',
    masterCheckedAt: 'Master-data state: {{date}}',
    applyField: 'Use the current value for {{field}}',
    documentValue: 'Saved document value',
    masterValue: 'Current master-data value',
    manualPreserved: 'Manually changed document value – it will not be overwritten automatically.',
    refreshSaved: 'The selected customer data was applied to the draft.',
    applyError: 'The selection could not be applied. The document was not changed.',
    applySelected: 'Apply {{count}} selected',
    validation: {
      title: 'Please correct the highlighted entries',
      customerRequired: 'Select a customer.',
      recipientRequired: 'Enter a document recipient.',
      itemRequired: 'Add at least one document item.',
    },
  },
  override: {
    open: 'Select customer data',
    title: 'Adjust customer data for this document',
    description:
      'These changes apply only to this draft. The tenant default remains unchanged. Follow-up documents use their document-type default and inherit values only for fields included there.',
    validationTitle: 'The document adjustment could not be saved',
    selectedTitle: 'Selection and preview',
    internalImpact: '{{count}} internal',
    externalImpact: '{{count}} in PDF or portal',
    labelLanguage: 'Label language',
    externalPermissionHint: 'Only authorized users can change PDF and portal approvals.',
    fieldLabel: 'Display label',
    section: 'Section',
    valueSource: 'Value to use',
    keepValue: 'Keep saved document value',
    resetValue: 'Restore from customer record',
    overrideValue: 'Override only in this document',
    captureOnSave: 'The appropriate value will be captured securely when saving.',
    resetValueHint: 'The current master-data value will be applied when saving.',
    sensitiveBlocked: 'This field cannot appear in the PDF or customer portal.',
    booleanYes: 'Yes',
    booleanNo: 'No',
    save: 'Save document adjustment',
    saved: 'The customer-data adjustment was saved for this document.',
    saveError: 'The document adjustment could not be saved.',
  },
  documentTypes: {
    QUOTE: 'Quote',
    ORDER: 'Order / order confirmation',
    DELIVERY_NOTE: 'Delivery note',
    INVOICE: 'Invoice',
    CANCELLATION: 'Cancellation',
    CREDIT_NOTE: 'Credit note',
    PURCHASE_ORDER: 'Purchase order',
  },
} as const;

export const customerHeaderTr = {
  ...customerHeaderEn,
  title: 'Belge başlığındaki müşteri verileri',
  subtitle: 'Her belge türü için alanları, bölümleri ve dış görünürlüğü yapılandırın.',
  documentType: 'Belge türü',
  loading: 'Başlık yapılandırması yükleniyor …',
  loadError: 'Başlık yapılandırması yüklenemedi.',
  retry: 'Tekrar dene',
  save: 'Değişiklikleri kaydet',
  saving: 'Kaydediliyor …',
  saved: 'Başlık yapılandırması kaydedildi.',
  reset: 'Belge türü varsayılanını geri yükle',
  cancel: 'İptal',
  confirm: 'Geri yükle',
  fieldsTitle: 'Kullanılabilir müşteri verileri',
  search: 'Alanlarda ve kategorilerde ara',
  standardFields: 'Standart alanlar',
  customFields: 'Ek alanlar',
  allSources: 'Tüm alanlar',
  allCategories: 'Tüm kategoriler',
  add: 'Ekle',
  selected: 'Seçili',
  layoutTitle: 'Bölümler ve sıralama',
  addSection: 'Özel bölüm oluştur',
  dragSection: 'Bölümü sürükleyip bırakarak taşı',
  dragField: 'Alanı sürükleyip bırakarak taşı',
  contexts: { internal: 'ERP içinde', pdf: 'PDF / baskı', portal: 'Müşteri portalı' },
  internal: 'Dahili',
  pdf: 'PDF',
  portal: 'Portal',
  sensitive: 'Gizli – yalnızca dahili',
  previewTitle: 'Yapı önizlemesi',
  editor: {
    title: 'Kayıtlı müşteri verileri',
    snapshotAt: '{{date}} tarihli belge durumu',
    densityLabel: 'Müşteri verisi görünümü',
    openCustomer: 'Müşteri kaydını aç',
    manageStandard: 'Belge türü varsayılanını yönet',
    checkCurrent: 'Güncel müşteri verilerini kontrol et',
    saveBeforeRefresh: 'Önce bekleyen belge değişikliklerini kaydedin.',
    internalOnly: 'Yalnızca dahili',
    showFullValue: '{{field}} alanının tam değerini göster',
    origins: {
      MASTER_DATA: 'Müşteri kaydından alındı',
      DOCUMENT_VALUE: 'Belgede saklandı',
      INHERITED: 'Önceki belgeden devralındı',
      MANUAL_OVERRIDE: 'Belgede elle değiştirildi',
      BACKFILL_CURRENT_MASTER: 'Güvenli eski belge aktarımında kaydedildi',
    },
    backfillTitle: 'Eski belgede kaynak bilgisi sınırlı',
    backfillDescription:
      'Adresler tarihsel belgedendir. Daha önce canlı okunan ana veriler, aktarım anında bilinen durum olarak işaretlenir.',
    empty: 'Bu belge için görünür müşteri verisi saklanmamış.',
    refreshTitle: 'Güncel müşteri verilerini kontrol et',
    refreshDescription:
      'Kayıtlı belge durumunu güncel müşteri kaydıyla karşılaştırın. Taslak ancak seçiminizi onayladığınızda değişir.',
    refreshLoading: 'Müşteri verileri karşılaştırılıyor …',
    refreshError: 'Karşılaştırma yüklenemedi',
    refreshErrorDescription: 'Lütfen tekrar deneyin. Belge değiştirilmedi.',
    noRefreshChanges: 'Belge durumu güncel müşteri verileriyle aynı.',
    masterCheckedAt: 'Ana veri durumu: {{date}}',
    applyField: '{{field}} için güncel değeri kullan',
    documentValue: 'Kayıtlı belge değeri',
    masterValue: 'Güncel ana veri değeri',
    manualPreserved: 'Elle değiştirilen belge değeri otomatik olarak ezilmez.',
    refreshSaved: 'Seçilen müşteri verileri taslağa uygulandı.',
    applyError: 'Seçim uygulanamadı. Belge değiştirilmedi.',
    applySelected: 'Seçilen {{count}} alanı uygula',
    validation: {
      title: 'İşaretli girdileri düzeltin',
      customerRequired: 'Bir müşteri seçin.',
      recipientRequired: 'Belge alıcısını girin.',
      itemRequired: 'En az bir belge kalemi ekleyin.',
    },
  },
  override: {
    open: 'Müşteri verilerini seç',
    title: 'Bu belge için müşteri verilerini ayarla',
    description:
      'Değişiklikler yalnızca bu taslak için geçerlidir; kiracı varsayılanı değişmez. Takip belgeleri kendi belge türü varsayılanını kullanır ve yalnızca orada bulunan alanların değerlerini devralır.',
    validationTitle: 'Belge ayarı kaydedilemedi',
    selectedTitle: 'Seçim ve önizleme',
    internalImpact: '{{count}} dahili',
    externalImpact: 'PDF veya portalda {{count}}',
    labelLanguage: 'Etiket dili',
    externalPermissionHint:
      'PDF ve portal izinlerini yalnızca yetkili kullanıcılar değiştirebilir.',
    fieldLabel: 'Görünen etiket',
    section: 'Bölüm',
    valueSource: 'Kullanılacak değer',
    keepValue: 'Kayıtlı belge değerini koru',
    resetValue: 'Müşteri kaydından geri yükle',
    overrideValue: 'Yalnızca bu belgede değiştir',
    captureOnSave: 'Uygun değer kayıt sırasında güvenle alınır.',
    resetValueHint: 'Kayıtta güncel ana veri değeri uygulanır.',
    sensitiveBlocked: 'Bu alan PDF veya müşteri portalında gösterilemez.',
    booleanYes: 'Evet',
    booleanNo: 'Hayır',
    save: 'Belge ayarını kaydet',
    saved: 'Müşteri verisi ayarı bu belge için kaydedildi.',
    saveError: 'Belge ayarı kaydedilemedi.',
  },
  documentTypes: {
    QUOTE: 'Teklif',
    ORDER: 'Sipariş / sipariş onayı',
    DELIVERY_NOTE: 'İrsaliye',
    INVOICE: 'Fatura',
    CANCELLATION: 'İptal belgesi',
    CREDIT_NOTE: 'Alacak dekontu',
    PURCHASE_ORDER: 'Satın alma siparişi',
  },
} as const;

export const customerHeaderFr = {
  ...customerHeaderEn,
  title: 'Données client dans l’en-tête du document',
  subtitle: 'Configurer les champs, sections et visibilités externes par type de document.',
  documentType: 'Type de document',
  loading: 'Chargement de la configuration …',
  loadError: 'Impossible de charger la configuration.',
  retry: 'Réessayer',
  save: 'Enregistrer les modifications',
  saving: 'Enregistrement …',
  saved: 'La configuration a été enregistrée.',
  reset: 'Rétablir le réglage par défaut',
  cancel: 'Annuler',
  confirm: 'Rétablir',
  fieldsTitle: 'Données client disponibles',
  search: 'Rechercher champs et catégories',
  standardFields: 'Champs standard',
  customFields: 'Champs personnalisés',
  allSources: 'Tous les champs',
  allCategories: 'Toutes les catégories',
  add: 'Ajouter',
  selected: 'Sélectionné',
  layoutTitle: 'Sections et ordre',
  addSection: 'Créer une section',
  dragSection: 'Déplacer la section par glisser-déposer',
  dragField: 'Déplacer le champ par glisser-déposer',
  contexts: { internal: 'ERP interne', pdf: 'PDF / impression', portal: 'Portail client' },
  internal: 'Interne',
  pdf: 'PDF',
  portal: 'Portail',
  sensitive: 'Confidentiel – interne uniquement',
  previewTitle: 'Aperçu de la structure',
  editor: {
    title: 'Données client enregistrées',
    snapshotAt: 'État du document au {{date}}',
    densityLabel: 'Affichage des données client',
    openCustomer: 'Ouvrir la fiche client',
    manageStandard: 'Gérer le réglage du type de document',
    checkCurrent: 'Vérifier les données client actuelles',
    saveBeforeRefresh: 'Enregistrez d’abord les modifications du document.',
    internalOnly: 'Interne uniquement',
    showFullValue: 'Afficher la valeur complète de {{field}}',
    origins: {
      MASTER_DATA: 'Capturé depuis la fiche client',
      DOCUMENT_VALUE: 'Enregistré dans le document',
      INHERITED: 'Hérité du document précédent',
      MANUAL_OVERRIDE: 'Modifié manuellement dans le document',
      BACKFILL_CURRENT_MASTER: 'Capturé lors de la reprise sécurisée',
    },
    backfillTitle: 'Provenance limitée pour l’ancien document',
    backfillDescription:
      'Les adresses proviennent du document historique. Les données auparavant lues en direct sont marquées avec l’état connu lors de la reprise.',
    empty: 'Aucune donnée client visible n’est enregistrée pour ce document.',
    refreshTitle: 'Vérifier les données client actuelles',
    refreshDescription:
      'Comparez l’état enregistré avec la fiche client actuelle. Le brouillon ne change qu’après confirmation de votre sélection.',
    refreshLoading: 'Comparaison des données client …',
    refreshError: 'Impossible de charger la comparaison',
    refreshErrorDescription: 'Veuillez réessayer. Le document n’a pas été modifié.',
    noRefreshChanges: 'L’état du document correspond aux données client actuelles.',
    masterCheckedAt: 'État des données de base : {{date}}',
    applyField: 'Utiliser la valeur actuelle pour {{field}}',
    documentValue: 'Valeur enregistrée du document',
    masterValue: 'Valeur actuelle de la fiche',
    manualPreserved: 'La valeur modifiée manuellement ne sera pas remplacée automatiquement.',
    refreshSaved: 'Les données client sélectionnées ont été appliquées au brouillon.',
    applyError: 'La sélection n’a pas pu être appliquée. Le document reste inchangé.',
    applySelected: 'Appliquer les {{count}} sélectionnées',
    validation: {
      title: 'Corrigez les saisies signalées',
      customerRequired: 'Sélectionnez un client.',
      recipientRequired: 'Saisissez un destinataire du document.',
      itemRequired: 'Ajoutez au moins une ligne au document.',
    },
  },
  override: {
    open: 'Sélectionner les données client',
    title: 'Adapter les données client de ce document',
    description:
      'Ces modifications ne concernent que ce brouillon. Le réglage du tenant reste inchangé. Les documents suivants utilisent le réglage de leur type et ne reprennent que les valeurs des champs qui y figurent.',
    validationTitle: 'Impossible d’enregistrer l’adaptation',
    selectedTitle: 'Sélection et aperçu',
    internalImpact: '{{count}} en interne',
    externalImpact: '{{count}} dans le PDF ou le portail',
    labelLanguage: 'Langue du libellé',
    externalPermissionHint:
      'Seuls les utilisateurs autorisés peuvent modifier le PDF et le portail.',
    fieldLabel: 'Libellé affiché',
    section: 'Section',
    valueSource: 'Valeur utilisée',
    keepValue: 'Conserver la valeur du document',
    resetValue: 'Restaurer depuis la fiche client',
    overrideValue: 'Remplacer uniquement dans ce document',
    captureOnSave: 'La valeur appropriée sera capturée lors de l’enregistrement.',
    resetValueHint: 'La valeur actuelle de la fiche sera appliquée à l’enregistrement.',
    sensitiveBlocked: 'Ce champ ne peut pas figurer dans le PDF ou le portail client.',
    booleanYes: 'Oui',
    booleanNo: 'Non',
    save: 'Enregistrer l’adaptation',
    saved: 'L’adaptation des données client a été enregistrée.',
    saveError: 'Impossible d’enregistrer l’adaptation.',
  },
  documentTypes: {
    QUOTE: 'Devis',
    ORDER: 'Commande / confirmation',
    DELIVERY_NOTE: 'Bon de livraison',
    INVOICE: 'Facture',
    CANCELLATION: 'Annulation',
    CREDIT_NOTE: 'Avoir',
    PURCHASE_ORDER: 'Commande fournisseur',
  },
} as const;

export const customerHeaderEs = {
  ...customerHeaderEn,
  title: 'Datos del cliente en la cabecera',
  subtitle: 'Configure campos, secciones y visibilidad externa por tipo de documento.',
  documentType: 'Tipo de documento',
  loading: 'Cargando configuración …',
  loadError: 'No se pudo cargar la configuración.',
  retry: 'Reintentar',
  save: 'Guardar cambios',
  saving: 'Guardando …',
  saved: 'La configuración se ha guardado.',
  reset: 'Restaurar valor predeterminado',
  cancel: 'Cancelar',
  confirm: 'Restaurar',
  fieldsTitle: 'Datos de cliente disponibles',
  search: 'Buscar campos y categorías',
  standardFields: 'Campos estándar',
  customFields: 'Campos adicionales',
  allSources: 'Todos los campos',
  allCategories: 'Todas las categorías',
  add: 'Añadir',
  selected: 'Seleccionado',
  layoutTitle: 'Secciones y orden',
  addSection: 'Crear sección propia',
  dragSection: 'Mover sección mediante arrastrar y soltar',
  dragField: 'Mover campo mediante arrastrar y soltar',
  contexts: { internal: 'ERP interno', pdf: 'PDF / impresión', portal: 'Portal de clientes' },
  internal: 'Interno',
  pdf: 'PDF',
  portal: 'Portal',
  sensitive: 'Confidencial – solo interno',
  previewTitle: 'Vista previa de estructura',
  editor: {
    title: 'Datos de cliente guardados',
    snapshotAt: 'Estado del documento del {{date}}',
    densityLabel: 'Presentación de datos de cliente',
    openCustomer: 'Abrir ficha del cliente',
    manageStandard: 'Gestionar predeterminado del tipo',
    checkCurrent: 'Comprobar datos actuales del cliente',
    saveBeforeRefresh: 'Guarde primero los cambios pendientes del documento.',
    internalOnly: 'Solo interno',
    showFullValue: 'Mostrar el valor completo de {{field}}',
    origins: {
      MASTER_DATA: 'Capturado de la ficha del cliente',
      DOCUMENT_VALUE: 'Guardado en el documento',
      INHERITED: 'Heredado del documento anterior',
      MANUAL_OVERRIDE: 'Modificado manualmente en el documento',
      BACKFILL_CURRENT_MASTER: 'Capturado en la migración segura de documentos antiguos',
    },
    backfillTitle: 'Procedencia limitada en documento antiguo',
    backfillDescription:
      'Las direcciones proceden del documento histórico. Los datos antes consultados en vivo se marcan con el estado conocido durante la migración.',
    empty: 'No hay datos de cliente visibles guardados para este documento.',
    refreshTitle: 'Comprobar datos actuales del cliente',
    refreshDescription:
      'Compare el estado guardado con la ficha actual. El borrador solo cambia tras confirmar su selección.',
    refreshLoading: 'Comparando datos del cliente …',
    refreshError: 'No se pudo cargar la comparación',
    refreshErrorDescription: 'Inténtelo de nuevo. El documento no se ha modificado.',
    noRefreshChanges: 'El estado del documento coincide con los datos actuales del cliente.',
    masterCheckedAt: 'Estado de datos maestros: {{date}}',
    applyField: 'Usar el valor actual para {{field}}',
    documentValue: 'Valor guardado del documento',
    masterValue: 'Valor actual de datos maestros',
    manualPreserved: 'El valor modificado manualmente no se sustituirá automáticamente.',
    refreshSaved: 'Los datos seleccionados se aplicaron al borrador.',
    applyError: 'No se pudo aplicar la selección. El documento no se ha modificado.',
    applySelected: 'Aplicar {{count}} seleccionados',
    validation: {
      title: 'Corrija los campos marcados',
      customerRequired: 'Seleccione un cliente.',
      recipientRequired: 'Introduzca un destinatario del documento.',
      itemRequired: 'Añada al menos una línea al documento.',
    },
  },
  override: {
    open: 'Seleccionar datos del cliente',
    title: 'Ajustar datos del cliente para este documento',
    description:
      'Los cambios solo se aplican a este borrador. El valor del tenant no cambia. Los documentos posteriores usan el valor predeterminado de su tipo y solo heredan los valores de los campos incluidos allí.',
    validationTitle: 'No se pudo guardar el ajuste',
    selectedTitle: 'Selección y vista previa',
    internalImpact: '{{count}} internos',
    externalImpact: '{{count}} en PDF o portal',
    labelLanguage: 'Idioma de etiqueta',
    externalPermissionHint: 'Solo usuarios autorizados pueden cambiar PDF y portal.',
    fieldLabel: 'Etiqueta visible',
    section: 'Sección',
    valueSource: 'Valor que usar',
    keepValue: 'Conservar valor guardado',
    resetValue: 'Restaurar desde la ficha',
    overrideValue: 'Cambiar solo en este documento',
    captureOnSave: 'El valor adecuado se capturará de forma segura al guardar.',
    resetValueHint: 'Al guardar se aplicará el valor maestro actual.',
    sensitiveBlocked: 'Este campo no puede aparecer en el PDF ni en el portal.',
    booleanYes: 'Sí',
    booleanNo: 'No',
    save: 'Guardar ajuste del documento',
    saved: 'El ajuste de datos del cliente se guardó para este documento.',
    saveError: 'No se pudo guardar el ajuste.',
  },
  documentTypes: {
    QUOTE: 'Oferta',
    ORDER: 'Pedido / confirmación',
    DELIVERY_NOTE: 'Albarán',
    INVOICE: 'Factura',
    CANCELLATION: 'Anulación',
    CREDIT_NOTE: 'Abono',
    PURCHASE_ORDER: 'Pedido de compra',
  },
} as const;

export const customerHeaderRu = {
  ...customerHeaderEn,
  title: 'Данные клиента в заголовке документа',
  subtitle: 'Настройте поля, разделы и внешнюю видимость для каждого типа документа.',
  documentType: 'Тип документа',
  loading: 'Загрузка конфигурации …',
  loadError: 'Не удалось загрузить конфигурацию.',
  retry: 'Повторить',
  save: 'Сохранить изменения',
  saving: 'Сохранение …',
  saved: 'Конфигурация сохранена.',
  reset: 'Восстановить стандарт',
  cancel: 'Отмена',
  confirm: 'Восстановить',
  fieldsTitle: 'Доступные данные клиента',
  search: 'Поиск полей и категорий',
  standardFields: 'Стандартные поля',
  customFields: 'Дополнительные поля',
  allSources: 'Все поля',
  allCategories: 'Все категории',
  add: 'Добавить',
  selected: 'Выбрано',
  layoutTitle: 'Разделы и порядок',
  addSection: 'Создать раздел',
  dragSection: 'Переместить раздел перетаскиванием',
  dragField: 'Переместить поле перетаскиванием',
  contexts: { internal: 'Внутри ERP', pdf: 'PDF / печать', portal: 'Портал клиента' },
  internal: 'Внутри',
  pdf: 'PDF',
  portal: 'Портал',
  sensitive: 'Конфиденциально – только внутри',
  previewTitle: 'Предпросмотр структуры',
  editor: {
    title: 'Сохранённые данные клиента',
    snapshotAt: 'Состояние документа на {{date}}',
    densityLabel: 'Вид данных клиента',
    openCustomer: 'Открыть карточку клиента',
    manageStandard: 'Настроить стандарт типа документа',
    checkCurrent: 'Проверить текущие данные',
    saveBeforeRefresh: 'Сначала сохраните изменения документа.',
    internalOnly: 'Только внутри',
    showFullValue: 'Показать полное значение {{field}}',
    origins: {
      MASTER_DATA: 'Получено из карточки клиента',
      DOCUMENT_VALUE: 'Сохранено в документе',
      INHERITED: 'Унаследовано из предыдущего документа',
      MANUAL_OVERRIDE: 'Изменено вручную в документе',
      BACKFILL_CURRENT_MASTER: 'Сохранено при безопасном переносе старых документов',
    },
    backfillTitle: 'Ограниченная история для старого документа',
    backfillDescription:
      'Адреса взяты из исторического документа. Данные, ранее читавшиеся в реальном времени, отмечены состоянием на момент переноса.',
    empty: 'Для этого документа нет сохранённых видимых данных.',
    refreshTitle: 'Проверить текущие данные',
    refreshDescription:
      'Сравните сохранённое состояние с текущей карточкой. Черновик изменится только после подтверждения.',
    refreshLoading: 'Сравнение данных …',
    refreshError: 'Не удалось загрузить сравнение',
    refreshErrorDescription: 'Повторите попытку. Документ не был изменён.',
    noRefreshChanges: 'Состояние документа совпадает с текущими данными.',
    masterCheckedAt: 'Состояние основных данных: {{date}}',
    applyField: 'Применить текущее значение для {{field}}',
    documentValue: 'Сохранённое значение',
    masterValue: 'Текущее значение',
    manualPreserved: 'Изменённое вручную значение не будет заменено автоматически.',
    refreshSaved: 'Выбранные данные применены к черновику.',
    applyError: 'Не удалось применить выбор. Документ не изменён.',
    applySelected: 'Применить выбранные ({{count}})',
    validation: {
      title: 'Исправьте отмеченные поля',
      customerRequired: 'Выберите клиента.',
      recipientRequired: 'Укажите получателя документа.',
      itemRequired: 'Добавьте хотя бы одну позицию.',
    },
  },
  override: {
    open: 'Выбрать данные клиента',
    title: 'Настроить данные для этого документа',
    description:
      'Изменения действуют только для этого черновика. Стандарт тенанта не меняется. Последующие документы используют стандарт своего типа и наследуют значения только для включённых в него полей.',
    validationTitle: 'Не удалось сохранить настройку',
    selectedTitle: 'Выбор и предпросмотр',
    internalImpact: '{{count}} внутри',
    externalImpact: '{{count}} в PDF или портале',
    labelLanguage: 'Язык метки',
    externalPermissionHint: 'Менять PDF и портал могут только уполномоченные.',
    fieldLabel: 'Отображаемая метка',
    section: 'Раздел',
    valueSource: 'Используемое значение',
    keepValue: 'Сохранить значение документа',
    resetValue: 'Восстановить из карточки',
    overrideValue: 'Изменить только в этом документе',
    captureOnSave: 'Подходящее значение будет безопасно сохранено.',
    resetValueHint: 'При сохранении будет применено текущее основное значение.',
    sensitiveBlocked: 'Это поле нельзя показывать в PDF или портале.',
    booleanYes: 'Да',
    booleanNo: 'Нет',
    save: 'Сохранить настройку',
    saved: 'Настройка данных клиента сохранена.',
    saveError: 'Не удалось сохранить настройку.',
  },
  documentTypes: {
    QUOTE: 'Предложение',
    ORDER: 'Заказ / подтверждение',
    DELIVERY_NOTE: 'Накладная',
    INVOICE: 'Счёт',
    CANCELLATION: 'Сторно',
    CREDIT_NOTE: 'Кредит-нота',
    PURCHASE_ORDER: 'Заказ поставщику',
  },
} as const;
